import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { settingsAPI } from '../utils/api';

const FooterContainer = styled.footer`
  background: #323232;
  color: white;
  padding: 60px 0 20px;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FooterSection = styled.div`
  h3 {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 30px;
      height: 2px;
      background: #ff6b35;
    }
  }
`;

const FooterLink = styled(Link)`
  color: #bdc3c7;
  text-decoration: none;
  display: block;
  padding: 5px 0;
  transition: color 0.3s ease;

  &:hover {
    color: #ff6b35;
  }
`;

const ContactInfo = styled.div`
  p {
    color: #bdc3c7;
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
      width: 22px;
      height: 22px;
      fill: #ff6b35;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  color: #ff6b35;
  border: 2px solid #ff6b35;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #ff6b35;
    color: #fff;
    transform: translateY(-2px);
    border-color: #ff6b35;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
    transition: fill 0.3s;
  }
  img {
    width: 22px;
    height: 22px;
    filter: brightness(0) saturate(100%) invert(48%) sepia(97%) saturate(749%) hue-rotate(353deg) brightness(101%) contrast(101%);
    /* #ff6b35 оранжевый */
    transition: filter 0.3s;
  }
  &:hover img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(200%) contrast(100%);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: #bdc3c7;
  font-size: 14px;
  margin: 0;
`;

const PaymentMethods = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  span {
    color: #bdc3c7;
    font-size: 14px;
    margin-right: 10px;
  }
`;

const CompanyInfo = styled.div`
  p {
    color: #bdc3c7;
    line-height: 1.6;
    margin: 10px 0;
  }
`;

const Footer = () => {
  // Значения по умолчанию для контактных данных
  const [contactData, setContactData] = useState({
    contactPhone: '+7 917 120-58-58',
    legalAddress: '446301, Самарская область, г Отрадный, Спортивная ул, д. 7',
    contactEmail: 'admin@foodstar.pro',
    workingHoursWeekdays: '9:00-20:00',
    workingHoursWeekend: '10:00-18:00',
    inn: '6318073403',
    telegramMain: '@foodstar163'
  });
  
  // Загрузка контактных данных из API
  useEffect(() => {
    const loadContactData = async () => {
      try {
        const response = await settingsAPI.get();
        if (response.data.success && response.data.settings) {
          const settings = response.data.settings;
          const defaults = {
            contactPhone: '+7 917 120-58-58',
            legalAddress: '446301, Самарская область, г Отрадный, Спортивная ул, д. 7',
            contactEmail: 'admin@foodstar.pro',
            workingHoursWeekdays: '9:00-20:00',
            workingHoursWeekend: '10:00-18:00',
            inn: '6318073403',
            telegramMain: '@foodstar163'
          };
          setContactData({
            contactPhone: settings.contactPhone || defaults.contactPhone,
            legalAddress: settings.legalAddress || defaults.legalAddress,
            contactEmail: settings.contactEmail || defaults.contactEmail,
            workingHoursWeekdays: settings.workingHoursWeekdays || defaults.workingHoursWeekdays,
            workingHoursWeekend: settings.workingHoursWeekend || defaults.workingHoursWeekend,
            inn: settings.inn || defaults.inn,
            telegramMain: settings.telegramMain || defaults.telegramMain
          });
        }
      } catch (error) {
        console.error('Ошибка загрузки контактных данных:', error);
        // Используем значения по умолчанию при ошибке
      }
    };
    
    loadContactData();
  }, []);
  
  // Формируем строку режима работы
  const workingHours = `Пн-Пт: ${contactData.workingHoursWeekdays}, Сб-Вс: выходной`;
  
  // Формируем ссылку на Telegram
  const telegramLink = contactData.telegramMain 
    ? `https://t.me/${contactData.telegramMain.replace('@', '')}`
    : 'https://t.me/lagomlife163';
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Яндекс.Метрика (счётчик 106350622)
    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) return;
      }
      k=e.createElement(t);a=e.getElementsByTagName(t)[0];k.async=1;k.src=r;a.parentNode.insertBefore(k,a);
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    window.ym(106350622, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      ecommerce: "dataLayer"
    });
    var _tmr = window._tmr || (window._tmr = []);
    _tmr.push({id: "3738340", type: "pageView", start: (new Date()).getTime()});
    (function (d, w, id) {
      if (d.getElementById(id)) return;
      var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
      ts.src = "https://top-fwz1.mail.ru/js/code.js";
      var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
      if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
    })(document, window, "tmr-code");
  }, []);
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <FooterSection>
            <h3>О компании</h3>
            <CompanyInfo>
              <p>
                Lagom Life — российская компания из Самарской области, которая создаёт научно обоснованные продукты для здоровья, красоты, спорта и активного образа жизни. Наша философия — баланс «лагом» во всём. Это не просто бренд, а сообщество людей с осознанным подходом к жизни и спорту.
              </p>
            </CompanyInfo>
          </FooterSection>

          <FooterSection>
            <h3>Информация</h3>
            <FooterLink to="/about">О нас</FooterLink>
            <FooterLink to="/delivery">Доставка и оплата</FooterLink>
            <FooterLink to="/returns">Возврат товара</FooterLink>
            <FooterLink to="/privacy_policy">Политика конфиденциальности</FooterLink>
            <FooterLink to="/cookie-policy">Политика использования cookie</FooterLink>
            <FooterLink to="/personal-data-consent">Согласие на обработку данных</FooterLink>
            <FooterLink to="/oferta">Публичная оферта</FooterLink>
            <FooterLink to="/contacts">Контакты</FooterLink>
            <FooterLink to="/experts">Эксперты</FooterLink>
            <FooterLink to="/become-expert">Стать экспертом</FooterLink>
            <FooterLink to="/news">Новости</FooterLink>
            <FooterLink to="/certificates">Сертификаты качества</FooterLink>
          </FooterSection>

          <FooterSection>
            <h3>Контакты</h3>
            <ContactInfo>
              <p>
                <svg viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                {contactData.contactPhone}
              </p>
              <p>
                <svg viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
                {contactData.legalAddress}
              </p>
              <p>
                <svg viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                {contactData.contactEmail}
              </p>
              <p>
                <svg viewBox="0 0 24 24">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                </svg>
                {workingHours}
              </p>
            </ContactInfo>

            <SocialLinks>
              <SocialLink href="https://vk.com/clublagomlife" target="_blank" aria-label="VK">
                <img src={process.env.PUBLIC_URL + '/soc_icon/vk-v2-svgrepo-com.svg'} alt="VK" />
              </SocialLink>
              <SocialLink href={telegramLink} target="_blank" aria-label="Telegram">
                <img src={process.env.PUBLIC_URL + '/soc_icon/telegram-svgrepo-com.svg'} alt="Telegram" />
              </SocialLink>
            </SocialLinks>
          </FooterSection>
        </FooterTop>

        <FooterBottom>
          <Copyright>
            Copyright © ООО "Лагом Лайф" 2025. Все права защищены. Копирование материалов запрещено.
            <br />
            <span style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginTop: 12, lineHeight: 1.5 }}>
              Информация на сайте и рекомендации экспертов не являются медицинской консультацией. БАД не являются лекарственными средствами. Перед применением проконсультируйтесь со специалистом.
            </span>
            <br />
            <span style={{ fontSize: '12px', color: '#9ca3af' }}>ИНН: {contactData.inn}</span>
          </Copyright>
          {/* Top.Mail.Ru counter */}
          <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `var _tmr = window._tmr || (window._tmr = []);
_tmr.push({id: "3738340", type: "pageView", start: (new Date()).getTime()});
(function (d, w, id) {
  if (d.getElementById(id)) return;
  var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
  ts.src = "https://top-fwz1.mail.ru/js/code.js";
  var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
  if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
})(document, window, "tmr-code");` }} />
          <img src="https://top-fwz1.mail.ru/counter?id=3738340;js=na" style={{ position: 'absolute', left: '-9999px' }} alt="Top.Mail.Ru" />
          <noscript><div><img src="https://top-fwz1.mail.ru/counter?id=3738340;js=na" style={{ position: 'absolute', left: '-9999px' }} alt="Top.Mail.Ru" /></div></noscript>
          {/* /Top.Mail.Ru counter */}
          <PaymentMethods>
            <span>Способы оплаты:</span>
            <img src={process.env.PUBLIC_URL + '/payments.png'} alt="Способы оплаты" style={{height: 32, width: 'auto', display: 'block'}} />
          </PaymentMethods>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 